

























import { Component, /*Prop,*/ Vue } from 'vue-property-decorator';
import { dataBus } from '@/rxjs/message';

@Component
export default class Controls extends Vue {
  toggleIcon = false;
  cursorStyle = "pointer";
  getData: any;
  back(): void {
    this.lockClicks('back')
  }
  rewind(): void {
    this.$store.dispatch('rewind', this.toggleIcon)
    this.toggleIcon = !this.toggleIcon
    this.cursorStyle = (this.cursorStyle==='pointer')? 'not-allowed':'pointer'
  }
  playPause(): void {
    this.$store.dispatch('playPause', this.toggleIcon)
    this.toggleIcon = !this.toggleIcon
    this.cursorStyle = (this.cursorStyle==='pointer')? 'not-allowed':'pointer'
  }
  next(): void {
    this.lockClicks('next') 
  }
  clear(){
    this.lockClicks('clear')
  }
  lockClicks(action: string): void{
    if(!this.toggleIcon){this.$store.dispatch(action)}
  }
  mounted(){
    this.getData = dataBus.getMessage().subscribe((pipe: any) => {if(pipe.message === "UNLOCK"){this.playPause()}});
  }
  beforeDestroy(){
    this.getData.unsubscribe()
  }
}
